"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _AirplanemodeActive = _interopRequireDefault(require("@material-ui/icons/AirplanemodeActive"));
var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));
var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));
var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));
var _Item = _interopRequireDefault(require("../components/Item"));
var _HeroBoard = _interopRequireDefault(require("../components/HeroBoard"));
var FlightPane = function FlightPane(_ref) {
  var date = _ref.date,
    title = _ref.title,
    arrival = _ref.arrival,
    departure = _ref.departure,
    phoneNumber = _ref.phoneNumber,
    flightNumber = _ref.flightNumber,
    backgroundImage = _ref.backgroundImage,
    reservationCode = _ref.reservationCode;
  var items = [{
    icon: /*#__PURE__*/_react["default"].createElement(_AirplanemodeActive["default"], {
      fontSize: "small"
    }),
    content: flightNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], {
      fontSize: "small"
    }),
    content: date
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], {
      fontSize: "small"
    }),
    content: reservationCode
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Phone["default"], {
      fontSize: "small"
    }),
    content: phoneNumber
  }];
  return /*#__PURE__*/_react["default"].createElement("div", null, backgroundImage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-0 h-48 bg-no-repeat bg-cover",
    style: {
      backgroundImage: "url(".concat(backgroundImage, ")")
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-8 pr-4"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "px-6 text-dark font-bold text-lg truncate"
  }, title), /*#__PURE__*/_react["default"].createElement(_HeroBoard["default"], {
    size: "sm",
    from: {
      label: departure.location,
      text: departure.code,
      subText: departure.time
    },
    to: {
      label: arrival.location,
      text: arrival.code,
      subText: arrival.time
    }
  }), items.map(function (_ref2, index) {
    var icon = _ref2.icon,
      content = _ref2.content;
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: index,
      size: "sm",
      icon: icon
    }, content);
  })));
};
var _default = exports["default"] = FlightPane;
//# sourceMappingURL=Flight.js.map